import { createReducer, on } from '@ngrx/store';
import { initialPatientProfileState } from './patient-profile.state';
import {
  autoSaveNewPetSuccess,
  resetPatientProfileState,
  setIsNewPet,
  setOngoingPet,
  setPatientProfile,
  setPatientWeight,
} from './patient-profile.actions';

/**
 * Patient Profile reducer
 */

export const patientProfileReducer = createReducer(
  initialPatientProfileState,
  on(setPatientProfile, (state, { profile }) => ({
    ...state,
    profile,
  })),
  on(setPatientWeight, (state, { weight }) => ({
    ...state,
    weight,
  })),
  on(setIsNewPet, (state, { isNewPet }) => ({
    ...state,
    isNewPet,
  })),
  on(setOngoingPet, (state, { ongoingPet }) => ({
    ...state,
    ongoingPet,
  })),
  on(autoSaveNewPetSuccess, (state, { pet }) => ({
    ...state,
    ongoingPet: pet,
  })),
  on(resetPatientProfileState, () => initialPatientProfileState),
);
